import FilePreviewComponent from "@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue";
import { GET_ANSWER_HISTORY_URL, get_headers } from "@/utils/constants/constants";
import axios from "axios";

export default {
  name: "ComplianceAnswerHistory",
  components: { FilePreviewComponent },
  props: {
    question: { type: Object, default: null },
    entity_profile_id: { type: [Number, String], required: true },
  },
  data: () => ({
    history_data: [],
    history_loading: false,
    history_page: 1,
    history_total_pages: 1,
    // file preview state
    show_file_preview: false,
    preview_file_url: "",
    preview_file_name: "",
  }),
  mounted() {
    this.load_history();
  },
  methods: {
    load_history() {
      this.history_loading = true;
      axios
        .get(GET_ANSWER_HISTORY_URL, {
          params: {
            compliance_field_id: this.question.compliance_field_id,
            entity_profile_id: this.entity_profile_id,
            page: this.history_page,
          },
          headers: get_headers(),
        })
        .then((response) => {
          if (response.data.status === "success") {
            const payload = response.data.data || {};
            // backend returns `history` (not `results`)
            this.history_data = Array.isArray(payload.history) ? payload.history : [];
            this.history_total_pages = payload.total_pages || 1;
            this.history_page = payload.page || this.history_page;
          }
        })
        .catch(() => {
          this.show_error("Error loading history:");
        })
        .finally(() => {
          this.history_loading = false;
        });
    },
    change_page(newPage) {
      if (newPage >= 1 && newPage <= this.history_total_pages) {
        this.history_page = newPage;
        this.load_history();
      }
    },
    format_datetime(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleString();
    },
    get_badge_class(status) {
      const classes = {
        submitted: "pending",
        verified: "manually-verified",
        changes_requested: "not-started",
      };
      return Reflect.get(classes, status) || "pending";
    },
    get_label(status) {
      const labels = {
        submitted: "Submitted",
        verified: "Verified",
        changes_requested: "Changes Requested",
      };
      return Reflect.get(labels, status) || status;
    },
    get_file_name_from_url(url) {
      if (!url) return "File";
      try {
        const urlObj = new URL(url);
        const name = urlObj.pathname.split("/").pop();
        return decodeURIComponent(name || "File");
      } catch (e) {
        const parts = String(url).split("?")[0].split("/");
        return Reflect.get(parts, parts.length - 1) || "File";
      }
    },
    open_file_preview(presignedUrl, fileName) {
      if (!presignedUrl) return;
      this.preview_file_url = presignedUrl;
      this.preview_file_name = fileName || this.get_file_name_from_url(presignedUrl);
      this.show_file_preview = true;
    },
    close_file_preview() {
      this.show_file_preview = false;
      this.preview_file_url = "";
      this.preview_file_name = "";
    },
  },
};
